import React, { useEffect, useState } from 'react'
import { useMediaQueries } from '../usecontext/UseProvider';
import { getOurCategories, deleteOurCategory } from '../services/OurCategories';
import { Box, Button, Card, CardMedia, Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import Header from '../adminComponents/header/Header';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import DeleteModal from '../adminComponents/deleteModal/DeleteModal';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useNavigate } from 'react-router-dom';

const Categories = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const { isSmallScreen, setLoading } = useMediaQueries();
    const [ourCategoriesData, setOurCategoriesData] = useState([])
    const navigate = useNavigate();

    const getOurCategoriesData = async () => {
        try {
            setLoading(true);
            const response = await getOurCategories();
            setOurCategoriesData(response?.categoryData);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getOurCategoriesData();
    }, []);

    const handleClick = (event, category) => {
        setSelectedCategory(category);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedCategory(null);
    };

    const handleOnDelete = () => {
        setDeleteOpen(true);
        setAnchorEl(null);
    };

    const handleDeleteConfirm = async () => {
        try {
            setLoading(true);
            const response = await deleteOurCategory(selectedCategory._id);
            if (response?.error) {
                console.error(response.error);
            } else {
                getOurCategoriesData();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
            setDeleteOpen(false);
            setSelectedCategory(null);
        }
    };

    return (
        <>
            <Header title="Categories" />
            <Box sx={{ pt: 3 }}>
                <Box textAlign={'end'} mb={2}>
                    <Button
                        onClick={() => navigate('/admin/manage-store/categories/add')}
                        variant="contained"
                        startIcon={<AddIcon sx={{ border: '2px dashed #FFFFFF', borderRadius: '50px', p: 0.5 }} />}
                        sx={{ bgcolor: "#01A0E2", color: "white", borderRadius: '30px' }}>
                        Add New Category
                    </Button>
                </Box>
                <Grid container spacing={3}>
                    {ourCategoriesData.map((category, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                            <Card
                                sx={{
                                    borderRadius: '0',
                                    position: 'relative',
                                    overflow: 'visible',
                                    boxShadow: 'none',
                                    '&:hover .title': {
                                        backgroundColor: '#01A0E2',
                                        color: '#fff'
                                    }, height: '100%',
                                    cursor: 'pointer'
                                }}
                            >
                                <Box sx={{ position: "absolute", top: 10, right: 10 }}>
                                    <IconButton
                                        sx={{ bgcolor: "rgba(255, 255, 255, 0.8)" }}
                                        size="small"
                                        onClick={(e) => handleClick(e, category)}
                                    >
                                        <MoreHorizIcon />
                                    </IconButton>

                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl) && selectedCategory?._id === category._id}
                                        onClose={handleClose}
                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                        sx={{ borderRadius: '10px' }}
                                    >
                                        <MenuItem onClick={() => {
                                            navigate(`/admin/manage-store/categories/${category._id}`);
                                            handleClose();
                                        }} sx={{ color: '#5B93FF' }}>
                                            <EditIcon fontSize="small" sx={{ mr: 1 }} /> Edit
                                        </MenuItem>
                                        <MenuItem onClick={handleOnDelete} sx={{ color: '#E71D36' }}>
                                            <DeleteIcon fontSize="small" sx={{ mr: 1, color: "error.main" }} /> Delete
                                        </MenuItem>
                                    </Menu>
                                </Box>
                                <CardMedia
                                    component="img"
                                    image={category.image.url}
                                    alt={category.name}
                                    sx={{ borderRadius: '0', height: '100%' }}
                                />
                                <Box
                                    className="title"
                                    sx={{
                                        position: 'absolute',
                                        left: '0', bottom: '50px',
                                        zIndex: 11,
                                        backgroundColor: 'white',
                                        width: { sm: '90%', xs: '75%' },
                                        py: 0.5,
                                        clipPath: 'polygon(0 0, 100% 0%, 90% 100%, 0% 100%)',
                                        display: 'inline-block'
                                    }}>
                                    <Typography className='title' variant={isSmallScreen ? "body1" : "h6"} sx={{ textAlign: 'left', ml: 2 }}>{category.name}</Typography>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <DeleteModal
                open={deleteOpen}
                handleDeleteClose={() => setDeleteOpen(false)}
                message="Are you sure you want to delete this Category?"
                handleOnClick={handleDeleteConfirm}
            />
        </>
    )
}

export default Categories